<template>
<div>
    <ul class="list-group discussions">
        <li v-if="post" :id="'post' + post.id" 
        v-bind:class="{
            'moderated': post.moderated==true,         
            }"     
        class="discussion clearfix">
            <div class="panel clearfix" v-if="post.moderated!==true">
                <div class="col-xs-12">
                   
                    <div class="col-xs-2">
                        <img v-bind:src="post.poster.avatar">
                        <div class="author">Posted By:<br />
                          <img :src="post.poster.roles | roleIcon(post.poster.terms)" class="role-icon">
                     
                            

                        <router-link :to="{ name: 'posts-by-user', query: { userId: post.poster.id } }">{{post.poster.firstName}} {{post.poster.lastName}}</router-link>
                        <br>{{post.createdAt | timeSince}} ago</div>
                    </div>

                    <div class="col-xs-10 form-group" v-if="editMode === true && post.topLevel">
                        <input v-model="title" type="text" class="form-control" placeholder="New Title">
                    </div>
            
                    <div class="col-xs-10">

                        <div v-if="topicCategories && editMode === false " class="categories">
                            Categories: 
                            <router-link 
                            :to="{ name: 'discussion', params: { forumId: forumId}, query: {filter_type: category.type, filter_id: category.id}} "
                            v-for="(category, $i) in topicCategories">
                            <span class="lowlight" v-if="$i!=0">, </span>{{category.name}}</router-link>
                            
                            Tags:
                            <router-link 
                            :to="{ name: 'discussion', params: { forumId: forumId}, query: {tag: tag.id}} "
                            v-for="(tag, $i) in tags">
                            <span class="lowlight" v-if="$i!=0">, </span>{{tag.name | ucwords}}</router-link>
                    
                        </div>

                        <div v-if="editMode === true">
                            <div v-if="localStorage.roles.indexOf('Student') > -1 && post.topLevel" class="form-group col-sm-12 nopad categories">
                                <label>Categories</label>

                                <div class="col-sm-4 nopad">

                                    <select 
                                    :class="{'placeholder': selectedCategories.term === ''}" 
                                    class="form-control" 
                                    v-model="selectedCategories.term">
                                        <option value="" default disabled>Term</option>
                                        <option v-for="term in categories.term" :value="term.id">
                                            {{term.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-4" v-if="selectedTermType !== 'foundation'">
                                    <select 
                                    :class="{'placeholder': selectedCategories.path === ''}" 
                                    class="form-control"  
                                    v-model="selectedCategories.path">
                                        <option value="" default>Learning Path</option>
                                        <option v-for="path in categories.path" :value="path.id">
                                            {{path.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-4 nopad">
                                    <select 
                                    :class="{'placeholder': selectedCategories.assignment === ''}" 
                                    class="form-control"                             
                                    v-model="selectedCategories.assignment">
                                    <option value="" default>Assignment</option>
                                        <option 
                                        v-if="canSeeAssignment(assignment)" 
                                        v-for="assignment in categories.assignment" 
                                        :value="assignment.id">
                                            {{assignment.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>    
                   
                            <div class="form-group" v-if="post.topLevel">
                                <label>Tags</label>
                                <input id="tags" @keydown.enter.prevent="addTag()" type="text" class="form-control" placeholder="Type a tag and press Enter or select one from the list">
                                <typeahead v-model="newTag" target="#tags" match-start :data="availableTags" item-key="name">
                                    <template slot="item" scope="props">
                                    <li v-for="(item, index) in props.items">
                                      <a role="button" @click="pushTag(item); newTag=null">
                                        {{item.name | ucwords}}
                                      </a>
                                    </li>
                                 
                                  </template>
                                </typeahead>
                                 <ul class="post-tags clearfix">
                                    <li v-for="(tag, $index) in tags">{{tag.name | ucwords}}<span class="remove" @click="tags.splice($index,1)">x</span></li>
                                </ul>

                            </div>


                        </div>

                        <div 
                        v-if="editMode===false" 
                        class="content post-content" 
                        :class="{'answer': post.isAnswer}"
                        v-html="$options.filters.linkify(post.body)"></div>
                        <div v-if="answer && answer !== null" class="answer">
                            <div class="header">Posted by {{answer.poster.firstName}} {{answer.poster.lastName}} on {{answer.createdAt | shortDate}}</div>
                            <div class="content post-content" v-html="$options.filters.linkify(answer.body)"></div>
                            <button v-if="threadCreator==localStorage.user_id" class="btn btn-danger btn-answer" @click.prevent="unmarkAnswer(answer.id)">Unmark Answer</button>

                        </div>
      

<!--                         <div class="form-group" v-if="editMode === true && post.topLevel">
                            <select v-model="newCategory" v-if="categories" class="form-control">
                                <option v-for="category in categories" :value="category.id">{{category.name}}</option>
                            </select>
                        </div> -->
            
                        <vue-html5-editor v-if="editMode===true" @change="editContent" :content="post.body" :height="300"></vue-html5-editor>
                        <button v-if="editMode===false" class="btn btn-success" @click.prevent="reply(post.body, post.poster.firstName, post.poster.lastName)">Reply</button>
                        <button v-if="post.isAnswer !== true && post.topLevel !== true && threadCreator==localStorage.user_id" class="btn btn-success btn-answer" @click.prevent="markAsAnswer(post.id)">Mark As Answer</button>

                        <button v-if="post.isAnswer == true && post.topLevel !== true && threadCreator==localStorage.user_id" class="btn btn-danger btn-answer" @click.prevent="unmarkAnswer(post.id)">Unmark Answer</button>


                        <button class="btn btn-success" v-if="editMode === true" @click.prevent="updatePost(post.id)">Save</button>

                        <button class="btn btn-success" v-if="post.createdBy === localStorage.user_id && editMode===false" @click.prevent="editMode = !editMode">Edit</button>
                        <button class="btn btn-success" v-if="post.createdBy === localStorage.user_id && editMode===true" @click.prevent="editMode = !editMode">Cancel</button>
                        <button v-if="editMode===false" class="btn btn-danger" @click.prevent="deleteComment" v-show="roles.indexOf('Supervisor') > -1 || post.createdBy === localStorage.user_id">Delete</button>
                    </div>
                </div>


            </div>

        </li>

    </ul>
    </div>
</template>

<script>
    import discussions from '../../../services/discussions';
    import toastr from 'toastr';
    import VueScrollTo from 'vue-scrollto';
    import { Typeahead } from 'uiv';

    export default {
        props: ['postData', 'topic', 'title','postCategories','tags','threadCreator','answerData'],
        template: '#post',
        name: 'discussion-post',
        data() {
            return {     
                post: null,
                answer:null,
                forumId: null,   
                editMode:false,  
                editedContent: null, 
                availableTags: [],
                topicCategories:null,
                newTag: null,
                selectedCategories: {
                    term: '',
                    path: '',
                    assignment: ''
                },
                categories:{
                    term: [],
                    path: [],
                    assignment:[]
                },
            };
        },
        components: { Typeahead },
        mounted() {     
            var self = this;
            
            this.forumId = this.$route.params.forumId;
            this.post = this.postData;
            this.answer = this.answerData;
            this.topicCategories = this.postCategories;

            if (this.topicCategories) {
                this.topicCategories.forEach(function(c) {
                    self.selectedCategories[c.type] = c.id;
                });
            }

            this.getCategories();
            this.getTags();

            if (this.$route.params.postId && this.$route.params.postId == this.post.id) {
                console.log(this.post.id);
                self.$nextTick(function() {
                    VueScrollTo.scrollTo('#post' + this.post.id, 0);
                });
            } 

            self.$bus.$on('marked_as_answer', function(post) {
                if (!post.id) {
                    self.post.isAnswer = false;
                    if (self.post.topLevel === true) {
                      
                        self.answer = null;
                        self.$forceUpdate();

                    }

                } else {
                    if (self.post.topLevel === true) {
                            self.answer = post;
                    }
                    post.id === self.post.id ? self.post.isAnswer = true : self.post.isAnswer = false;
                }
            })

            $('body').on('click', '.post-content img', function(e) { 
                let urls = [];
                let clicked = $(e.currentTarget).attr('src');
                if (!clicked.includes('ttto-discussion-images-full')) {
                    clicked = clicked.replace('ttto-discussion-images','ttto-discussion-images-full');
                }
                $(this).closest('.post-content').find('img').each(function(i, ele){ 
                    let src = ele.getAttribute('src');
                    if (!src.includes('ttto-discussion-images-full')) {
                        src = src.replace('ttto-discussion-images','ttto-discussion-images-full');
                    }
                    urls.push(src);
                });

                self.$bus.$emit('open_lightbox',urls, clicked);
            });

        },
        methods: {
            pushTag(tag) {
                let alreadyTagged = this.tags.findIndex(function(t) { return t.id === tag.id});
                if (alreadyTagged === -1) {
                    this.tags.push(tag);
                }
            },
            addTag() {
                var self = this;
                let tags = self.newTag;

                if (tags.indexOf(',') > -1) tags = tags.split(','); else tags = [tags];

                tags.forEach(function(tag) {
                    tag = tag.toLowerCase().trim();

                    let exists = self.tags.findIndex(function(t) { return t.name == tag});
                    self.newTag = null;
                    if (exists === -1) {                
                        discussions.createTag(self, tag).then(function(response) {
                            self.availableTags.push(response.data.tag);
                            self.tags.push(response.data.tag);
                        });
                    } else {
                        setTimeout(function() {
                            document.getElementById('tags').value = '';
                        },200);   
                        let alreadyTagged = self.tags.findIndex(function(t) { return t.id === self.tags[exists].id});
                        if (alreadyTagged === -1) {
                            self.tags.push(self.tags[exists]);
                        }
                    }
                })
                         
            },
            getTags() {
                var self = this;
                discussions.getTags(this).then(function(response) {
                    self.availableTags = response.data.tags;
                });
            },
            canSeeAssignment(assignment) {
                var self = this;    
                if (!this.selectedTermType) return true;
                if (this.selectedTermType === 'foundation' && assignment.termType === 'foundation') return true;
                let i = this.categories.path.findIndex(function(p) { return p.id === self.selectedCategories.path});
                if (i === -1) return false;
                return assignment.paths.indexOf(parseInt(this.categories.path[i].associatedId)) > -1;          
            },
            markAsAnswer(postId) {
                var self = this;
                discussions.markAsAnswer(this, postId, this.topic).then(function(response) {                    
                    self.$bus.$emit('marked_as_answer', self.post);
                    response.data.success === true ? toastr.success('Marked as Answer') : toastr.error('Error marking as answer');
                });
            },
            unmarkAnswer(postId) {
                var self = this;
                discussions.unmarkAnswer(this, postId, this.topic).then(function(response) {
                    self.$bus.$emit('marked_as_answer', {id: null})
                });
            },
            reply(body, firstName, lastName) {
                this.$bus.$emit('reply_to_post', body, firstName, lastName);
            },
            getCategories() {
                var self = this;
                discussions.getCategories(this, this.forumId).then(function(response) {
                    if (response.data.success === true) {              
                        let cats = response.data.categories;

                        cats.forEach(function(cat) {
                            self.categories[cat.type].push(cat);
                        });

                 
                    } else {
                        toastr.error('Error getting categories');
                    }
                })
            },
            editContent(content) {
                this.editedContent = content;
            },
            deleteComment() {
                var self = this;

                var areYouSure = confirm('Are you sure you want to delete this?');
               
                if (areYouSure === true) {               
                    discussions.delete(this, this.post.id).then(function() {
                        if (self.post.topLevel === true) {
                             self.$router.push('/discussion/' + self.forumId);
                        }
                        self.$bus.$emit('postAdded');
                    });
                }
                
            },
            updatePost(id) {

                var self = this;
           
                var data = {
                    id: id                   
                }

                if (this.editedContent) {
                    self.post.body = this.editedContent;
                    data.content = this.editedContent
                } else {
                    data.content = this.post.body;
                }               


                if (this.post.topLevel) {
                    data.title = this.title,
                    data.topicId = self.topic,
                    data.categories = Object.keys(this.selectedCategories)
                        .map(function (key) { return self.selectedCategories[key]; })
                        .filter(function(i) { return i !== null && i !== ''});

                    data.tags = this.tags.map(function(t) { return t.id });
                }


                discussions.update(this, data).then(function(response) {
                    if (response.data.success === true) {
                        self.topicCategories = Object.keys(self.selectedCategories).map(function(key) {
                            let index = self.categories[key].findIndex(function(t) {
                                return t.id === self.selectedCategories[key];
                            })
                            if (index !== -1) {
                                return self.categories[key][index];
                            }
                          //  console.log(JSON.stringify(self.categories, null,2));
                        }).filter(function(e) { return e; })
                        console.log(JSON.stringify(self.selectedCategories,null,2));                        
                        toastr.success('Post updated');
                        self.editMode = false;
                        self.editedContent = null; 
                        self.$bus.$emit('title_changed', self.title);
                    } else {
                        toastr.error('Error updating message');
                    }
                })
            }, 

    },
    computed: {
        selectedTermType() {
            let self = this;
            let t = self.selectedCategories.term;
            if (t) {
                let index = this.categories.term.findIndex(function(t) { return t.id === self.selectedCategories.term})
                return this.categories.term[index].termType;
            }
        },
          roles() {
            return localStorage.getItem('roles');
        },
    }
}
</script>

<style lang="scss">
.post-content.content {
    img {
        max-height:200px;
        max-width:200px;
        height:auto;
        cursor:pointer;
        display:block;
    }
    span {
        background:transparent!important;
    }

}
</style>


<style lang="scss" scoped>
.answer {
    margin-top:2rem;
    background: #2e492c;
    color:#fff;
    .header {
        padding:1rem;
        box-shadow:none;
    }
    .post-content, &.post-content {
        background:  lighten(#2e492c,10%);
    }
}
.btn-answer {
    background:#2e492c;
    color:#fff;
}
  .content {
    background: lighten(#303030, 10%);
    padding:1rem;

}
.author {
    font-style:italic;
    padding-bottom:2rem;
    a {
        color:#33ccff;
    }
}
button {
    float:right;
    margin-top:2rem;
}
.discussions {
    background:#222;

}
.discussion {
    list-style-type:none;
    margin:0;
    padding-left:2rem;        
    .panel {
        background:#303030;
        padding:1rem;
        padding-top:2rem;
        margin-bottom: 0;
        padding-bottom:0;
        box-shadow:3px 6px 15px rgba(0,0,0,.5);    
    }   
}

.btn {
    border-width:0px!important;
    margin-bottom: 20px;
    margin-right: 6px;
}

.btn-danger {
    //margin-top:1px;
    top: 0px;
    //right:6px;
    position: relative;
}

.instructor-moderated {
    background:#b62516;
    h3 {
        margin-bottom:4rem;
    }
}

.post-content {
    box-shadow:0px 0px 30px rgba(0,0,0,.2);
    blockquote {
        padding: 10.5px 21px;
        margin: 0 0 21px;
        font-size: 14px!important;
        border-left: 5px solid #464545;
        background: rgba(0,0,0,.2);
        color: #ccc;
        box-shadow: 3px 2px 5px rgba(0,0,0,.1);
    }
    span {
        background:transparent!important;
    }
}

.categories {
    font-size:12px;
    margin-bottom: 5px;
    & > label {
        display: block!important;
    }
    span {
        color: #33ccff;
    }
    .lowlight {
        color:#b0b0b0;
    } 
    a:hover {
        text-decoration: none;
    }
}

select.placeholder {
    color:#b0b0b0;
}
</style>

<style>
  .content img {
    max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// DiscussionPost.vue?37cfc8fd